<div class="head">
  @if (icon()) {
    <img class="icon" [style.width]="maxSize() + 'px !important'" [src]="icon()" alt="logo_step" draggable="false" />
  }
  @if (cardTitle()) {
    <div class="title">{{ cardTitle() }}</div>
  }
  @if (subtitle()) {
    <div class="subtitle">{{ subtitle() }}</div>
  }
</div>
